let title = ' | Gestor - Comercial Ivaiporã'

const entrega = {
    path: '/consulta-credito',
    props: true,
    component: () => import('@/Components/ConsultaCredito/ConsultaCreditoContainer.vue'),
    children: [
        {
            path: '',
            name: 'ConsultaCredito',
            component: () => import('@/Components/ConsultaCredito/ConsultaCreditoLimite.vue'),
            meta: {
                title: 'Consulta' + title,
                permission: 'sortercurve_menu',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Consulta de Limite',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/consulta_credito',
                    }
                ]
            }
        }
    ]
}

export default entrega